var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFraudTrackingMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5400_1190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7956 30.6667H1.46224V1.33333H22.7956V7.81333L24.1289 8.33333V1.33333C24.1289 0.596667 23.5322 0 22.7956 0H1.46224C0.725573 0 0.128906 0.596667 0.128906 1.33333V30.6667C0.128906 31.4033 0.725573 32 1.46224 32H22.7956C23.5322 32 24.1289 31.4033 24.1289 30.6667V24.6893L22.7956 25.3333V30.6667Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7956 5.33333H5.46224V6.66667H18.7956V5.33333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1289 10.6667H5.46224V12H11.1289V10.6667Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79557 16H5.46224V17.3333H9.79557V16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8788 12.2078C16.318 8.77958 21.0749 7.97752 24.5031 10.4167L24.8169 10.6518C27.8602 13.0583 28.6005 17.3806 26.5435 20.6628L31.8716 24.8067L31.0526 25.8594L25.7401 21.7273C23.1857 24.5642 18.8552 25.0978 15.6698 22.8314L15.356 22.5958C12.2968 20.1766 11.5622 15.8209 13.6594 12.5326L13.8788 12.2078ZM23.7303 11.5033C20.9022 9.49103 16.9777 10.1524 14.9654 12.9805C12.9533 15.8086 13.6147 19.7326 16.4426 21.7449C19.2706 23.7569 23.1946 23.0955 25.2069 20.2676C27.219 17.4396 26.5581 13.5157 23.7303 11.5033Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7956 12H19.4622V18H20.7956V12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7956 20H19.4622V21.3333H20.7956V20Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5400_1190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraudTrackingMenu);
export default __webpack_public_path__ + "static/media/fraud_tracking_menu.fe51eb59967c71618923e31c199364d9.svg";
export { ForwardRef as ReactComponent };